import { useEffect, useState } from 'react'
import { signInWithCustomToken } from 'firebase/auth'
import { auth } from '@/lib/firebase'
import { useAuth } from './use-auth'

export interface Impersonation {
  adminUid: string
  adminEmail: string
}

/** Signs in with a custom token minted by the admin panel (see api: POST /admin/users/:uid/impersonate). */
export const signInImpersonated = (token: string) => signInWithCustomToken(auth, token)

/** Who is behind this session, when a platform admin signed in as the user. Null for a normal sign-in. */
export function useImpersonation(): Impersonation | null {
  const { user } = useAuth()
  const [state, setState] = useState<Impersonation | null>(null)

  useEffect(() => {
    let cancelled = false
    if (!user) {
      setState(null)
      return
    }
    // the claim rides on the ID token and is kept on refresh
    user
      .getIdTokenResult()
      .then(({ claims }) => {
        if (cancelled) return
        const adminUid = claims.impersonated_by
        setState(typeof adminUid === 'string' ? { adminUid, adminEmail: String(claims.impersonated_by_email ?? '') } : null)
      })
      .catch(() => !cancelled && setState(null))
    return () => {
      cancelled = true
    }
  }, [user])

  return state
}
